import * as Sentry from '@sentry/react-native';

/** Static — never interpolate the rejected URL (attacker-controlled). */
export const SKIPPED_OKTA_LOGOUT_REDIRECT_MESSAGE =
  'Okta (web): logout skipped untrusted redirect; Okta session may still be active';

/**
 * Local logout already finished; the Okta-side redirect was skipped because the
 * server-supplied URL failed the CWE-601 host check. Sentry is the alertable
 * channel; hostname only, never the full URL.
 */
export function reportSkippedOktaLogoutRedirect(
  rejectedHost: string,
  expectedHost: string,
): void {
  console.warn(`⚠️ ${SKIPPED_OKTA_LOGOUT_REDIRECT_MESSAGE}`);
  Sentry.withScope(scope => {
    scope.setLevel('warning');
    scope.setTag('cwe', '601');
    scope.setTag('operation', 'okta.web.logout.redirect');
    scope.setExtra('rejectedHost', rejectedHost);
    scope.setExtra('expectedHost', expectedHost);
    Sentry.captureMessage(SKIPPED_OKTA_LOGOUT_REDIRECT_MESSAGE);
  });
}
